const H = {
  name: "Chip",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 9H9V15H15V9ZM11 13V11H13V13H11Z" fill="currentColor"/>
<path d="M11 2V5H13V2H15V5H16C17.6569 5 19 6.34315 19 8V9H22V11H19V13H22V15H19V16C19 17.6569 17.6569 19 16 19H15V22H13V19H11V22H9V19H8C6.34315 19 5 17.6569 5 16V15H2V13H5V11H2V9H5V8C5 6.34315 6.34315 5 8 5H9V2H11ZM7 16C7 16.5523 7.44772 17 8 17H16C16.5523 17 17 16.5523 17 16V8C17 7.44772 16.5523 7 16 7H8C7.44772 7 7 7.44772 7 8V16Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Chip
};
